import domReady from '@wordpress/dom-ready';

domReady(() => {
	const selector = '.js-es-block-form';

	const forms = document.querySelectorAll(selector);

	if (!forms.length) {
		return;
	}

	forms.forEach((form) => {
		// Move additional class from selector to classes.
		const customClasses = form?.dataset?.typeSelector ?? '';
		let jobName = '';

		if (customClasses?.length) {
			customClasses?.split(' ')?.forEach((item) => {
				if (item.startsWith('jobName:')) {
					jobName = item.replace('jobName:', '');
				} else {
					form.classList.add(item);
				}
			});
		}

		// Workable form logic.
		if ((form?.dataset?.formType ?? '') === 'workable') {
			form.querySelectorAll('.es-field__label-inner').forEach((label) => {
				if (label.innerHTML.trim() === 'Label') {
					label.parentElement.style.display = 'none';
				}
			});

			// Push dataLayer event on job application form submission.
			window.addEventListener('esFormsAfterFormSubmitSuccess', ({ detail }) => {
				const { formId, esForms } = detail;

				// Only trigger for this specific form
				if (esForms.store.getStateFormElement(formId) !== form) {
					return;
				}

				window?.dataLayer?.push({
					event: 'job-application',
					jobName,
				});
			});
		}
	});
});
